import PolicyEntitlement from "./policyEntitlement";
import PolicyGeneralInfo from "./policyGeneralInfo";
import PolicyApproval from "./policyApproval";
import PolicyAdvancedSetting from "./policyAdvancedSetting";

const createLeaveTabs = [
  {
    label: "General",
    number: 1,
    title: "General Information",
    subtitle: null,
    forms: (props) => <PolicyGeneralInfo {...props} />,
  },
  {
    label: "Entitlement",
    number: 2,
    title: "Entitlement",
    subtitle: "Set the entitlement policy for this leave.",
    forms: (props) => <PolicyEntitlement {...props} />,
  },
  {
    label: "Approval",
    number: 3,
    title: "Approval",
    subtitle:
      "Choose from configured approval flow or create new flow for this leave",
    forms: (props) => <PolicyApproval {...props} />,
  },
  {
    label: "Advanced settings",
    number: 4,
    title: "Advanced settings",
    forms: (props) => <PolicyAdvancedSetting {...props} />,
  },
];

export default createLeaveTabs;
